export default "__VITE_ASSET__991aef96__"